import { z } from "zod/v4";

export type SetMetafieldMutation = {
  __typename?: "Mutation";
  metafieldsSet?: {
    __typename?: "MetafieldsSetPayload";
    userErrors: Array<{
      __typename?: "MetafieldsSetUserError";
      field?: Array<string> | null;
      message: string;
    }>;
    metafields?: Array<{
      __typename?: "Metafield";
      key: string;
      namespace: string;
      type: string;
      value: string;
    }> | null;
  } | null;
};

export const InitializeAppDataRequestBodySchema = z.nullable(z.any());

export type InitializeAppDataRequestBodyType = z.infer<
  typeof InitializeAppDataRequestBodySchema
>;

export type InitializeAppDataResponseBodyType = SetMetafieldMutation;
